import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <br />
      <a
        rel="noopener noreferrer"
        href="https://github.com/Alina-Goncalves/weather-forecast-react"
        target="_blank"
      >
        Open-Source Code {""}
      </a>
      by
      <a
        rel="noopener noreferrer"
        href="https://www.linkedin.com/in/alinacgon%C3%A7alves/"
        target="_blank"
      >
        {" "}
        Alina Gonçalves{" "}
      </a>
    </div>
  );
}
